/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import history from "browserHistory";
import useAsync from "hooks/useAsync";
import useToast from "hooks/useToast";
import getContactByIdService from "services/contact/getContactByIdService";
import ScreenLoading from "components/ScreenLoading";
import NewContactLayout from "./NewContactLayout";
import EditContactLayout from "./EditContactLayout";

function ContactFormScreen({ match }) {
  const { action, id } = match.params;
  const { showError } = useToast();
  const [contact, setContact] = React.useState();

  const [fetch, pending] = useAsync({
    promiseFn: getContactByIdService,
    onData: (data) => setContact(data),
    onError: (error) => {
      console.log(error);
      showError("An error happened.");
      history.push("/contacts");
    },
  });

  React.useEffect(() => {
    if (id) {
      fetch({ id });
    }
  }, []);

  if (id && (pending || !contact)) return <ScreenLoading />;
  if (action !== "new" && action !== "edit") return <></>;

  return {
    new: <NewContactLayout contact={contact} onContactChange={setContact} />,
    edit: <EditContactLayout contact={contact} onContactChange={setContact} />,
  }[action];
}

export default ContactFormScreen;
